import { createAction, ActionsUnion } from 'utils/redux'
import { Activity } from '.'

export enum ActivityMonitorActionTypes {
  ACTIVITY_CREATE = 'ACTIVITY_CREATE',
  ACTIVITIES_CREATE = 'ACTIVITIES_CREATE',
  ACTIVITY_COMPLETE = 'ACTIVITY_COMPLETE',
  ACTIVITIES_COMPLETE = 'ACTIVITIES_COMPLETE'
}

type ActivityArgs = Omit<Activity, 'id'>

export const ActivityMonitorActions = {
  createActivity: (activityArgs: ActivityArgs) =>
    createAction(ActivityMonitorActionTypes.ACTIVITY_CREATE, { id: activityArgs.negotiationUpdate.entityId, ...activityArgs }),
  createActivities: (activityArgs: ActivityArgs[]) =>
    createAction(
      ActivityMonitorActionTypes.ACTIVITIES_CREATE,
      activityArgs.map(activity => ({
        id: activity.negotiationUpdate.entityId,
        ...activity
      }))
    ),
  completeActivity: (activityArgs: ActivityArgs) =>
    createAction(ActivityMonitorActionTypes.ACTIVITY_COMPLETE, { id: activityArgs.negotiationUpdate.entityId, ...activityArgs }),
  completeActivities: (activities: Record<string, ActivityArgs>) => createAction(ActivityMonitorActionTypes.ACTIVITIES_COMPLETE, activities)
}

export type ActivityMonitorActions = ActionsUnion<typeof ActivityMonitorActions>
